import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { solutions } from "@/mocks/solutions";

export default function Solutions() {
  return (
    <section id="soluciones" className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Soluciones"
          title="Tu negocio tiene un problema. Nosotros construimos la solución."
        />

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-4">
          {solutions.map((item, i) => (
            <Reveal key={item.id} delay={(i % 2) * 80}>
              <div className="group flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6 transition-all duration-300 hover:border-accent-300 hover:shadow-[0_12px_32px_rgba(30,60,120,0.06)]">
                <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-50 text-accent-600 transition-colors duration-300 group-hover:bg-accent-500 group-hover:text-background-50">
                  <i className={`${item.icono} text-xl`} />
                </div>
                <div>
                  <p className="font-semibold text-foreground-950">
                    {item.problema}
                  </p>
                  <p className="mt-1 text-sm text-foreground-600 flex items-center gap-1.5">
                    <i className="ri-arrow-right-line text-primary-500 text-sm" />
                    {item.solucion}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}